import styled from 'styled-components';

export const ExercisePreviewContainer = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 15px;
  background: white;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const ExercisePreviewHeader = styled.div`
  padding: 15px;
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const ExerciseImageThumb = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 6px;
  overflow: hidden;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ExerciseInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ExerciseName = styled.h4`
  margin: 0 0 8px 0;
  font-size: 1.1rem;
  color: #333;
  font-weight: 600;
`;

export const ExerciseDetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 8px;
  font-size: 0.9rem;
  color: #666;
`;

export const ExerciseDetail = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  strong {
    color: #333;
    font-weight: 500;
  }
`;

export const ExerciseActions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const ExerciseActionButton = styled.button`
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 4px;

  &.edit {
    background: #e3f2fd;
    color: #1976d2;

    &:hover {
      background: #bbdefb;
    }
  }

  &.delete {
    background: #ffebee;
    color: #d32f2f;

    &:hover {
      background: #ffcdd2;
    }
  }
`;

export const MoveButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-right: 10px;

  i {
    cursor: pointer;
    color: #999;
    font-size: 0.9rem;
    padding: 4px;
    border-radius: 3px;
    transition: all 0.2s;

    &:hover {
      background: #f0f0f0;
      color: #333;
    }
  }
`;

export const ExerciseNotes = styled.div`
  padding: 12px 15px;
  background: #f8f9fa;
  border-top: 1px solid #e0e0e0;
  font-size: 0.9rem;
  color: #666;
  line-height: 1.4;

  strong {
    color: #333;
    display: block;
    margin-bottom: 4px;
  }
`;
